import React from "react";

export interface CrossIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CrossIcon: React.FC<CrossIconProps> = ({ width = 20, height = 20, color = "#868697" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 0.999939L1 12.9999M1 0.999939L13 12.9999" stroke={color} strokeWidth="1.99991" strokeLinecap="round" />
    </svg>
  );
};

export default CrossIcon;
